import { render, staticRenderFns } from "./FirmMembers.vue?vue&type=template&id=7d91fb4b&scoped=true&"
import script from "./FirmMembers.vue?vue&type=script&lang=js&"
export * from "./FirmMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d91fb4b",
  null
  
)

export default component.exports